import(/* webpackMode: "eager" */ "/home/runner/work/brics-website/brics-website/app/[locale]/experts/page.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["ExpertsSearchable"] */ "/home/runner/work/brics-website/brics-website/sections/experts-searchable/experts-searchable.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HeaderPage"] */ "/home/runner/work/brics-website/brics-website/shared/ui/header-page/header-page.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/brics-website/brics-website/shared/utils/common.js");
;
import(/* webpackMode: "eager" */ "/home/runner/work/brics-website/brics-website/shared/utils/hooks.tsx");
